<template>
  <v-expansion-panel
    v-model="discountPanel"
    expand
    class="elevation-0 mx-0 px-0 my-3"
  >
    <v-expansion-panel-content
      class="v-expansion-panel-content__wrap px-3"
    >
      <template v-slot:header>
        <span class="subheading font-weight-regular">{{ $t('Included Discounts') }}</span>
      </template>
      <slot />
    </v-expansion-panel-content>
  </v-expansion-panel>
</template>

<script>
export default {
  name: 'OrderDiscountExpandableHeader',

  data () {
    return {
      discountPanel: [false]
    }
  }
}
</script>

<style scoped>
.v-expansion-panel-content__wrap >>> .v-expansion-panel__header {
  padding: 0 !important;
}
</style>
